// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__XYSZS","itemTitle":"ClientEmergencyInfo_itemTitle__2sXss","itemText":"ClientEmergencyInfo_itemText__34l9q"};